import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';
import { PreviewProduitComponent } from "src/app/shared/components/preview-produit/preview-produit.component";


@Component({
  selector: 'app-detail-produit-bareme',
  templateUrl: './detail-produit-bareme.component.html',
  styleUrls: ['./detail-produit-bareme.component.scss']
})
export class DetailProduitBaremeComponent implements OnInit {

  @Input('selectedBareme') selectedBareme :any
  @Output() onUpdateBareme = new EventEmitter<any>();
  itemsStatutInitialized=[]
  itemToSave: any = {};
  itemProduit: any = {};
  filiale_id:any
  user: any = {};
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  @Input('bareme_id') bareme_id: any;
  itemsFiliale: any;
  itemProduitBareme:any= {};
  itemsStatut: any;

  constructor(
    private authService: AuthService,
    public bsModalRef: BsModalRef,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('change: ',changes)
    if (changes.bareme_id.currentValue) {
      console.log('La valeur a changé de', changes.bareme_id.previousValue, 'à', changes.bareme_id.currentValue);
      
      setTimeout(() => {
        
        if(changes.bareme_id.currentValue){
          this.getItemProduitBareme(changes.bareme_id.currentValue)
        }
      });
    }
  }


  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  

  getItemProduitBareme(bareme_id) {

    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        bareme_id : bareme_id
      },
    };

    this.busyGet = this.restClient
      .post("produitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemProduitBareme = res["items"][0]
     
         
          } else {
            this.itemProduitBareme = {}
          }
        },
        (err) => {
          this.itemProduitBareme = {}
         }
      );
  }
 
  getItemsStatut() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("statut/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsStatut = _.orderBy(res["items"], ["libelle"], ["asc"]);
            this.itemsStatutInitialized = [...this.itemsStatut];
            this.itemsStatutInitialized.sort((a, b) => this.customSort(a, b));
            this.get_nombre_par_famille();
            this.getItemsPrimeProduit();
          } else {
            this.itemsStatut = [];
          }
        },
        (err) => {
          this.itemsStatut = [];
        }
      );
  }
  
  get_nombre_par_famille() {
    this.itemToSave.nombre_personnes_famille = 0;
    this.itemsStatutInitialized.map((isi) => {
      this.itemToSave.nombre_personnes_famille += Number(isi.nombre_autorise);
    });
  }

  getItemsPrimeProduit() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        bareme_id: this.itemToSave.bareme_id,
      },
    };
    // debugger

    this.busyGet = this.restClient
      .post("primeProduit/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            let itemsPrime = res["items"];
            if (itemsPrime && itemsPrime.length) {
              itemsPrime.map((ip) => {
                ip.codification =
                  this.itemsStatut &&
                  this.itemsStatut.filter((ig) => ig.id == ip.statut_id)
                    ? this.itemsStatut.filter((ig) => ig.id == ip.statut_id)[0]
                        .codification
                    : "";
              });
            }

            this.itemsStatutInitialized.map((isi) => {
              if (isi.codification == "A") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "A")[0]
                    : {};
                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "C") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "C")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "E") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "E")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "ASC") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "ASC")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
              if (isi.codification == "AU") {
                let item =
                  itemsPrime && itemsPrime.length
                    ? itemsPrime.filter((ip) => ip.codification == "AU")[0]
                    : {};

                isi.prime = item.prime;
                isi.plafond = item.plafond;
                isi.age_min = item.age_min;
                isi.age_max = item.age_max;
                isi.nombre_autorise = item.nombre_autorise;
                isi.nombre_supplementaire_autorise =
                  item.nombre_supplementaire_autorise;
                isi.surprime_si_supplementaire =
                  item.surprime_si_supplementaire;
              }
            });
            this.get_nombre_par_famille();

            console.log("itemsPrime: ", itemsPrime);
          } else {
            // this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          // this.itemsReseauDeSoin = [];
        }
      );
  }
   customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }

  openModalPrestataireReseau(){}
  ngOnInit() {
    this.getItemsStatut()
  }

}
